import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Navigate, Routes } from 'react-router-dom';
import userContext from '../context/userContext';
import Layout from '../components/layout'
import Home from '../screens/home'
import Detail from '../screens/detail';
import Login from '../screens/login';
import Register from '../screens/register';
import SetPassword from '../screens/setPassword';


const Navigation = () => {
    const { user } = useContext(userContext);
    return (
        <Router>
            <Routes >                
                <Route exact path="/login" element={<Login/>} />
                <Route exact path="/register" element={<Register/>} />
                <Route exact path="/set-password" element={<SetPassword/>} />
                <Route path="/" element={<Layout/>}>
                    <Route exact path="/" element={<Home/>} />
                    <Route exact path="/turf/:id" element={<Detail/>} />
                </Route>
            </Routes>
        </Router>
    )
}

export default Navigation;
